export const searchParams = {
  trail: {
    populate: {
      gallery: {
        populate: "*",
      },
      trackFiles: {
        populate: {
          file: {
            populate: "*",
          },
        },
      },
    },
  },
  // Экотропы: скалярные поля идут списку точек, details и галерея — карточке,
  // которая открывается по клику на маршруте. Список fields не задаём
  // намеренно: Strapi отвечает 400, если запросить поле, которого ещё нет
  // в схеме на сервере.
  ecotraps: {
    populate: {
      details: {
        populate: "*",
      },
      gallery: {
        populate: "*",
      },
    },
    pagination: {
      pageSize: 100,
    },
  },
  stations: {
    populate: {
      gallery: {
        populate: "*",
      },
      services: {
        populate: "*",
      },
    },
  },
  page: {
    populate: "*",
  },
  webCams: {
    populate: {
      previewImage: {
        populate: "*",
      },
      cameraPosition: {
        populate: "*",
      },
      cameraDetail: {
        populate: "*",
      },
    },
  },
  restaurants: {
    populate: {
      photos: {
        populate: "*",
      },
      detailInfo: {
        populate: {
          detailList: {
            populate: "*",
          },
        },
      },
      workTimeList: {
        populate: "*",
      },
    },
  },
  accommodations: {
    populate: {
      photos: {
        populate: "*",
      },
      detailInfo: {
        populate: {
          detailList: {
            populate: "*",
          },
        },
      },
      workTimeList: {
        populate: "*",
      },
    },
  },
  culturalObjects: {
    populate: {
      backgroundImage: {
        populate: "*",
      },
      detailInfo: {
        populate: {
          detailList: {
            populate: "*",
          },
        },
      },
      workTimeList: {
        populate: "*",
      },
    },
  },
};
